import styled from 'styled-components';
import { inputStyles, variables } from 'components/theme';
import { searchBackgroundColor, searchTextColor } from 'utils/theme';

export function inputStyle(props) {
  if (props.disabled) {
    return inputStyles.disabled;
  }
  if (props.error) {
    return inputStyles.error.focus;
  }
  if (props.variant) {
    return inputStyles[props.variant];
  }
  return inputStyles.default;
}

export function focusStyles(props) {
  if (props.disabled) {
    return inputStyles.disabled.focus;
  }
  // if (props.error) {
  //   return inputStyles.error.focus;
  // }
  if (props.variant) {
    return inputStyles[props.variant].focus;
  }
  return inputStyles.default.focus;
}

export function paddingStyles() {
  return '11px 14px';
}

export function prefixPaddingStyles() {
  return '11px 14px 11px 58px';
}

export const SuffixIcon = styled.button`
  position: absolute;
  right: 0px;
  top: 0px;
  height: 43px;
  width: 45px;
  display: flex;
  cursor: pointer;
  justify-content: center;
  background-color: ${variables.colors.grey19};
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  border: 0.5px solid ${variables.colors.grey7};
  border-bottom: none;

  svg {
    height: 100%;
  }
`;

export const PrefixIcon = styled.span`
  position: absolute;
  left: 0px;
  top: 0px;
  height: 43px;
  width: 45px;
  display: flex;
  justify-content: center;
  background-color: ${variables.colors.grey19};
  border: 0.5px solid ${variables.colors.grey7};
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  border-bottom: none;

  svg {
    height: 100%;
  }

  @media screen and (max-width: 768px) {
    border-bottom: 0.5px solid ${variables.colors.grey7};
  }
`;

export const InputWrapper = styled.span`
  display: flex;
  flex-direction: column;
  position: relative;
  min-height: 35px;
  height: 60px;
`;

export const Error = styled.p`
  font-size: 14px;
  line-height: 2.8;
  min-height: 21px;
  color: red;
  transition: color 0.3s cubic-bezier(0.215, 0.61, 0.355, 1);
`;

export const StyledInput = styled.input`
  /* Common styles */
  ${props => inputStyle(props)}
  width: ${props => (props.width ? props.width : '100%')};
  padding: ${props =>
    props.prefixIcon ? prefixPaddingStyles(props) : paddingStyles(props)};
  border-radius: 8px;
  /* Focus */
  &:focus {
    ${props => focusStyles(props)}
  }
  /* Placeholder */
  &:-ms-input-placeholder,
  &:-moz-placeholder,
  &::-webkit-input-placeholder {
    color: ${variables.colors.grey4};
  }
`;

// Search Input
export const SearchWrapper = styled.div`
  display: flex;
  border-radius: 10px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1);
  margin-bottom: 28px;

  @media screen and (max-width: 768px) {
    margin-bottom: 14px;
  }
`;

export const SearchButton = styled.button`
  all: unset;
  width: 100%;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 20px;
  border-radius: 10px;
  padding: ${({ buttonPadding }) =>
    buttonPadding ? buttonPadding : '18px 20px'};
  background: ${searchBackgroundColor};
  transition: all 0s linear;
  outline: 0;

  svg {
    fill: ${searchTextColor};
    vertical-align: middle;
  }

   /* Button Text */
  & > span {
    font-size: 18px;
    ${variables.fonts.openSansSemiBold}
    color: ${searchTextColor};
  }

  @media screen and (min-width: 768px) {
    svg {
      width: 24px;
      height: 24px;
    }
  }

  @media screen and (max-width: 768px) {
    padding: 14px;
  }
`;

export const StyledSearchInput = styled.input`
  flex: 2;
  border: none;
  font-size: 18px;
  border-radius: 0 10px 10px 0;
  background: ${searchBackgroundColor};
  color: ${searchTextColor};
  ${variables.fonts.openSansSemiBold}
  cursor: pointer !important;

  /* Placeholder */
  &::placeholder {
    font-size: 18px;
    ${variables.fonts.openSansSemiBold}
    color: ${searchTextColor};
  }

  @media screen and (max-width: 768px) {
    &::placeholder {
      font-size: 14px;
    }
  }
`;
